<template>
  <router-view />
</template>

<script>
import { wxshareInit } from "@/plugins/wechatSDK.js"
import "@/plugins/bridge.js"
export default {
  created() {
    window.ZsrbApp.call("shareInfo", {
      title: "必胜！一键生成专属海报，为中山18919名高考学子加油！",
      img: "https://zsrbactivity.zsnews.cn" + require("./assets/zsplus.jpg"),
      desc: "中山+邀全城市民助力高考！",
      url: "https://zsrbactivity.zsnews.cn/vue/universityposter/"
    })
    wxshareInit({
      title: "必胜！一键生成专属海报，为中山18919名高考学子加油！",
      imgUrl: "https://zsrbactivity.zsnews.cn" + require("./assets/zsplus.jpg"),
      description: "中山+邀全城市民助力高考！",
      url: "https://zsrbactivity.zsnews.cn/vue/universityposter/",
      successMethod: ""
    })
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
* {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.btn {
  width: 200px;
  height: 28px;
  line-height: 28px;
  font-size: 3.8vw;
  color: #ffffff;
  border-radius: 12px;
  margin: -10px auto;
  padding: 2px 4px;
}
.ech-shake {
  animation: shake 1s ease;
}
@keyframes shake {
    0%, 100% {
        transform: translateX(0);
    }
    10%, 30%, 50%, 70%, 90% {
        transform: translateX(-6px);
    }
    20%, 40%, 60%, 80% {
        transform: translateX(6px);
    }
}
.button.glass {
  position: relative;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    animation: glass 1.5s infinite;
    background: left / auto 100% no-repeat url("./assets/img/gif_button.png");
  }
  @keyframes glass {
    0% {
      left: 0;
    }
    50% {
      left: 100%;
      opacity: 0;
    }
    100% {
      left: 100%;
      opacity: 0;
    }
  }
}
.ech-shake-time {
    animation: shake-time 1s ease-in-out .5s ;
}

.ech-shake-time-delay {
    animation: shake-time 1s ease-in-out 1.5s ;
}

@keyframes shake-time {
    0% {
        transform: scale(1);
    }
    10%, 20% {
        transform: scale(0.9) rotate(-3deg);
    }
    30%, 50%, 70%, 90% {
        transform: scale(1.1) rotate(3deg);
    }
    40%, 60%, 80% {
        transform: scale(1.1) rotate(-3deg);
    }
    100% {
        transform: scale(1) rotate(0);
    }
}
// 逐渐放大
.fd {
    opacity: 0;
    animation: fd .8s ease 1 forwards;
    // opacity: 1\9\0;
}
@keyframes fd {
  0% {
    transform: scale(0);
  }
  100% {
      transform: scale(1);
      opacity: 1;
  }
}
</style>
